export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Soluzione di workspace essenziale, con funzionalità intelligenti per i lavoratori moderni che utilizzano SaaS, applicazioni web e servizi di condivisione di file.</p><p>Include l’SSO con il supporto per l’autenticazione multi-fattore per tutte le applicazioni; il workspace intelligente con microapp, feed personalizzati e assistenza virtuale; inoltre, il servizio Citrix Content Collaboration Standard con storage dei file illimitato.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Soluzione di workspace completa per i lavoratori che necessitano di un workspace totalmente digitale dotato di sicurezza granulare, ma che non richiedono applicazioni e desktop virtuali.</p><p>Include le funzionalità di Workspace Standard, oltre ai controlli di sicurezza avanzati per SaaS e web, unified endpoint management e Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Una soluzione di workspace completa che comprende opzioni di distribuzione ibrida per Citrix Virtual Apps and Desktops.</p><p>Include le funzionalità di Workspace Premium, oltre a un’opzione di gestione del cloud per Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials aiuta le aziende di piccole e medie dimensioni a proteggere i propri dati semplificando e rendendo sicure le procedure di accesso alle applicazioni web e SaaS.</p><p>Include il single sign-on alle applicazioni web e SaaS con autenticazione multi-fattore per proteggere ulteriormente le procedure di accesso, contribuendo a ridurre del 99,9% le probabilità di compromissione dell'account.</p>"
            },
            terms: "*Per utente, al mese",
            btn1: "Visualizzate la tabella delle funzionalità"
        },
        features: {
            disclaimer1: "*MSRP (prezzo consigliato dal produttore) medio mensile in USD per utente, per 500 utenti con un abbonamento di 3 anni. I prezzi effettivi potrebbero variare.<br /> Le opzioni di licenza per Citrix Workspace partono da 25 utenti.",
            disclaimer2: "**Il servizio Workspace Premium non include Workspace Analytics per le distribuzioni in locale di Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Selezionate la vostra edizione",
            title: "Calcolate il prezzo",
            users: "Selezionate il numero di utenti",
            estCost: "Stima del costo mensile",
            btn1: "Parlate con un esperto",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Le opzioni di licenza partono da 25 utenti. Riprovare.",
            lowUserMsg: "Avete meno di 500 utenti? Possiamo aiutarvi con le vostre esigenze per piccole e medie imprese.",
            volumeDiscount: "Avete più di 2.500 utenti? Approfittate degli sconti per volumi elevati.",
            contract1: "Contratto di 1 anno",
            contract3: "Contratto di 3 anni",
            contract3savings: "Risparmi del 20%",
            term: "Per utente, al mese",
            disclaimer: "*Questo strumento di calcolo fornisce prezzi stimati e può essere utilizzato unicamente per la creazione di budget. I prezzi effettivi possono variare. Contattate il vostro team o il partner Citrix per l’applicazione di eventuali sconti."
        },
        stats: {
            title: "I vostri vantaggi",
            stat1: {
                title: "Migliorate l’esperienza dei dipendenti",
                desc: "<b>4 leader IT su 5</b> ritengono che l’esperienza utente sia fondamentale per la trasformazione digitale."
            },
            stat2: {
                title: "Offrite libertà di scelta ai dipendenti",
                desc: "<b>Il 78%</b> dei dirigenti d’azienda concordano sul fatto che consentire ai dipendenti di scegliere le applicazioni e i dispositivi utilizzati aiuta a migliorare l’esperienza dei dipendenti."
            },
            stat3: {
                title: "Semplificate l’accesso",
                desc: "<b>Il 47%</b> dei dirigenti aziendali afferma che il maggior contributo in termini di coinvolgimento dei dipendenti è dato dalla facilità di accesso alle informazioni necessarie per svolgere il lavoro."
            },
            btn1: "Parlate con un esperto",
            disclaimer: "Fonte: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}